import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'
import type { FC } from 'react'
import { Link } from 'react-router-dom'
import { t } from 'ttag'

const StyledLink = styled(Link)(() => ({
  textDecoration: 'none',
  marginBottom: 20,
  display: 'inline-block'
}))

const BackButton: FC<{ link?: string; label?: string }> = ({
  link = '/',
  label = t`To frontpage`
}) => {
  const theme = useTheme()
  return (
    <StyledLink to={link}>
      <Button sx={{ color: theme.palette.text.primary }} startIcon={<ArrowBackIcon />}>
        {label}
      </Button>
    </StyledLink>
  )
}
export default BackButton
